export default {
  outList: [
    {
      light_point_1: [
        {
          title: '潮动锋芒矩阵格栅',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: '流光溢彩，雕塑般立体，尽显潮流与活力',
        },
      ],
      light_point_3: [

        {
          title: '凌风溜背造型+飒酷鳍线尾翼',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '运动基因与潮流气息兼备，灵动流畅'
        },
      ]
    }
  ],
  innerList: [
    {
      light_point_1: [
        {
          title: '20.5吋星云环绕屏',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '视觉享受；交互智能；轻松便捷',
        },
      ],
      light_point_2: [
        {
          title: 'Lion 5.0   AI科技智慧座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/3/4.jpg',
          text: '丰富娱乐生态；音乐、听书、视频；应有尽有',
        },
      ],
      light_point_3: [
        {
          title: '一体式舒享运动座椅',
          type: 'image',
          video: '',
          image: 'lightPoint/1/5.jpg',
          text: '符合人体工程学，长途驾驶也能轻松惬意'
        },
      ]
    }
  ],
  tab1: [
    {
      title: '黄金比例宽体潮流车身',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '时尚与动感风范的完美融合，一眼心动',
      text2: ''
    },
    {
      title: '潮动锋芒矩阵格栅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '流光溢彩，雕塑般立体，尽显潮流与活力',
    },
    {
      title: '全LED疾风炫影灯组',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '前后灯组呼应联动，犀利动感，个性十足'
    },
    {
      title: '凌风溜背造型+飒酷鳍线尾翼',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '运动基因与潮流气息兼备，灵动流畅'
    },
    {
      title: '一体式舒享运动座椅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '符合人体工程学，长途驾驶也能轻松惬意'
    },
    {
      title: '17寸运动轮毂+高能红色卡钳',
      type: 'image',
      video: '',
      image: 'lightPoint/1/6.jpg',
      text: '动感时尚，锋芒毕露，彰显运动激情'
    },
  ],
  tab2: [
    {
      title: '1.5T+9速CVT白金动力组合',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '动力输出高效稳定，市区近郊皆轻松驾驭',
    },
    {
      title: 'ESP车身电子稳定系统',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '更舒适的驾驶享受，更稳定也更安全'
    },
  ],
  tab3: [
    {
      title: '20.5吋星云环绕屏',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '视觉享受；交互智能；轻松便捷',
    },
    {
      title: '540°影像',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '洞悉周围环境',
      text2: '驾驶更安全',
    },
    {
      title: 'EPB+AUTOHOLD',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '便捷安全；优化体验',
      text2: '驻车更轻松',
    },
    {
      title: 'Lion 5.0   AI科技智慧座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/3/4.jpg',
      text: '丰富娱乐生态；音乐、听书、视频；应有尽有',
    },
  ]
}
